import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: 10em 0 5em 0;

	.content-container {
		padding: 2.5em;

		.headline {
			margin: 0 0 1.5rem 0;
			font-size: 2.18em;
			font-weight: 600;
		}

		.form-container {
			max-width: 500px;

			.form-inputs {
				margin: 2.8em 0 0 0;
				display: flex;
				align-self: flex-start;
				flex-flow: column nowrap;

				.input-container {
					position: relative;
					margin: 0 0 1em 0;

					.button-display-password {
						position: absolute;
						font-size: 0.7em;
						top: 3.5em;
						right: 20px;
						font-weight: 600;
						text-decoration: underline;
					}
					.input {
						padding-right: 120px;
					}
				}
			}
			.submit-button {
				margin: .6em 0 0 0;
				justify-content: flex-start;
			}
		}
	}

	.layout-forms-input {
		.layout-forms-input-wrapper {
			.label-wrapper {
				.label-body {
					.layout-forms-input-label {
						opacity: 1;
						color: #000000;
						transform: translateY(0);
						font-size: 0.9em;
						margin-bottom: 0.5em;
					}
				}
			}
			.internal-wrapper {
				.input-body {
					.input {
						text-align: flex-start;
						letter-spacing: 1px;
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		.content-container {
			max-width: 100%;
			width: 100%;

			.form-container {
				max-width: 500px;

				.form-inputs {
					display: flex;
					.input-container {
						.button-display-password {
						top: 3em;
					}
						.input {
							padding-right: 90px;
						}
					}
				}
			}

			.layout-forms-input {
				.layout-forms-input-wrapper {
					.label-wrapper {
						.label-body {
							.layout-forms-input-label {
								font-size: 0.6em;
							}
						}
					}
				}
			}
		}
	}
	@media all and (max-width: ${vars.mobileM}) {
		.content-container {

			.form-container {

				.form-inputs {
					.input-container {
						.button-display-password {
						top: 4.8em;
					}

					}
				}
			}
		}
	}
`;
